;(function() {
  'use strict'

  Service.$inject = ["$q", "productsResource"];
  angular.module('core.services').service('products', Service)

  /* @ngInject */
  function Service($q, productsResource) {
    var SearchTypes = {
      SUFFIX: 'suffix',
      PREFIX: 'prefix',
      ANY: 'any',
    }

    return {
      search: search,
      SearchTypes: SearchTypes,
    }

    function search(query, searchType) {
      return $q(function(resolve, reject) {
        var data = {}
        switch (searchType || SearchTypes.ANY) {
          case SearchTypes.SUFFIX:
            data.filter = 'gtin regex /' + query + '$/i'
            break
          case SearchTypes.PREFIX:
            data.filter = 'gtin regex /^0*' + query + '/i'
            break
          case SearchTypes.ANY:
            data.filter = 'gtin regex /' + query + '/i'
            break
        }

        productsResource
          .search(data)
          .success(function(x, products) {
            resolve(products)
          })
          .error(reject)
      })
    }
  }
})()
